// extracted by mini-css-extract-plugin
module.exports = {"logoNavigation":"logo-navigation_BW509","logoNavigationHeaderHidden":"logo-navigation_4leQs","logoWithText":"logo-navigation_1gIq_","logoNoText":"logo-navigation_2eTRd"};